




























































import HeadingInline from "@/components/HeadingInline.vue";
import SettingsCredentialsItem from "@/components/analytics/SettingsCredentialsItem.vue";
import SettingsCredentialsAdd from "@/components/analytics/SettingsCredentialsAdd.vue";
import { Settings, Credentials } from "@/types/settings";
import url from "@/mixins/analytics/url";
import { Getter } from "vuex-class";
import { Component, Mixins } from "vue-property-decorator";

@Component({
  components: { HeadingInline, SettingsCredentialsAdd, SettingsCredentialsItem },
})
export default class SettingsCredentials extends Mixins(url) {
  @Getter("settings/activeCacheSettings") settings!: Settings;

  rotateSSOButtonTitle = "Rotate SSO Secret";

  isSaving = false;

  get credentials() {
    const credentials = this.settings.credentials;
    return [
      credentials.find(credential => credential.primary),
      ...credentials.filter(credential => !credential.primary),
    ];
  }

  credentialRowTitle({ primary }: Credentials) {
    return primary
      ? "This row shows the primary credentials for this cache.  The primary credentials are the username and password stored with your cache provider (e.g. Heroku, Azure, Rackspace, etc.)"
      : "";
  }

  rotateSSO() {
    if (
      window.confirm(
        "Clicking OK will rotate the SSO secret for your cache. This will require you to login again. Are you sure you want to do this?",
      )
    ) {
      this.$ga.button(this.rotateSSOButtonTitle);

      this.rotateSSOButtonTitle = "Rotating";
      this.isSaving = true;
      this.$store.dispatch("rotateSSO").then(() => {
        this.$store.dispatch("logout");
      });
    }
  }
}
